export const environment = {
  production: false,
  apiUrl: 'https://api.mkassa2.uz/',
} as const;
